module.exports = __webpack_public_path__ + "static/media/27.2832af24.jpg";